import React, { useState, useEffect, useCallback } from "react";
import ButtonInstallPWA from "../components/ButtonInstallPWA";
import { isPWA as isPWAFunc } from "../utils/pwaUtil";
import { Outlet } from "react-router-dom";
import { isMobile } from "../utils/deviceUtilClient";
// https://react-vant.3lang.dev/components/config-provider
import { ConfigProvider } from "react-vant";

const vantThemeVars = {
  // rateIconFullColor: "#ffcc56",
  // sliderBarHeight: "4px",
  // sliderButtonWidth: "20px",
  // sliderButtonHeight: "20px",
  // sliderActiveBackgroundColor: "#951fff",
  // buttonPrimaryBorderColor: "#951fff",
  // buttonPrimaryBackgroundColor: "#951fff",
};

function LayoutProvider({
  children,
}: Readonly<{
  children?: React.ReactNode;
}>) {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallPWAButton, setShowInstallPWAButton] = useState(false);
  // 是否支持 PWA
  const [isPWA, setIsPWA] = useState(false);

  useEffect(() => {
    setIsPWA(isPWAFunc());
  }, []);

  // useEffect(() => {
  //   window.addEventListener("beforeinstallprompt", (e) => {
  //     e.preventDefault();
  //     setDeferredPrompt(e);
  //     setInstallPWAButton(true);
  //   });
  // }, []);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      // 阻止默认的安装提示
      e.preventDefault();
      // 保存事件对象以便稍后使用
      setDeferredPrompt(e);
      setShowInstallPWAButton(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    // 清理事件监听器
    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const handleInstallPWA = useCallback(() => {
    if (!deferredPrompt) {
      return;
    }
    deferredPrompt.prompt();
    deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        console.log("用户接受了 PWA 安装");
      } else {
        console.log("用户拒绝了 PWA 安装");
      }
      // TODO: 不明原因, 点击取消后依然可用, 但输出了 "用户拒绝了 PWA 安装"
      // setDeferredPrompt(null);
      // setShowInstallPWAButton(false);
    });
  }, [deferredPrompt]);

  // 初次加载弹出提示
  // NotAllowedError: Failed to execute 'prompt' on 'BeforeInstallPromptEvent': The prompt() method must be called with a user gesture
  // 必须在用户交互（如点击按钮）中调用
  // useEffect(() => {
  //   if (deferredPrompt) {
  //     handleInstallPWA();
  //   }
  // }, [deferredPrompt, handleInstallPWA]);

  return (
    <>
      {/* <ConfigProvider themeVars={vantThemeVars}> */}
        {children ?? <Outlet />}
        {isMobile() && !isPWA && deferredPrompt && (
          <ButtonInstallPWA onClick={handleInstallPWA} />
        )}
        {/* TODO: 始终会显示, 并且拒绝后按钮会闪烁 */}
        {/* {showInstallPWAButton && <ButtonInstallPWA onClick={handleInstallPWA} />} */}
      {/* </ConfigProvider> */}
    </>
  );
}

export default LayoutProvider;
